import { render, staticRenderFns } from "./IssueBar.vue?vue&type=template&id=4646aae5"
import script from "./IssueBar.vue?vue&type=script&lang=js"
export * from "./IssueBar.vue?vue&type=script&lang=js"
import style0 from "./IssueBar.vue?vue&type=style&index=0&id=4646aae5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports